import constants from "../constants";

const {
  UPDATE_CLIENTS,
  UPDATE_CLIENTS_STORE,

  UPSERT_CLIENT,
  UPSERT_CLIENT_STORE,

  REMOVE_CLIENT,
  REMOVE_CLIENT_STORE,

  CREATE_MAIN_USER,
  CHECK_CAPTCHA,
} = constants;

export const updateClients = (data) => ({
  type: UPDATE_CLIENTS,
  data,
});

export const updateClientsStore = (data) => ({
  type: UPDATE_CLIENTS_STORE,
  data,
});

export const upsertClient = (client) => ({
  type: UPSERT_CLIENT,
  data: client,
});

export const upsertClientStore = (client) => ({
  type: UPSERT_CLIENT_STORE,
  data: client,
});

export const removeClient = (uid) => ({
  type: REMOVE_CLIENT,
  data: uid,
});

export const removeClientStore = (removedId) => ({
  type: REMOVE_CLIENT_STORE,
  removedId,
});

export const sendCreateMainUser = (data) => ({
  type: CREATE_MAIN_USER,
  data,
});

export const sendCheckCaptcha = (data) => ({
  type: CHECK_CAPTCHA,
  data,
});
